export default function BlogHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-600 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-4 py-2 bg-teal-500/20 backdrop-blur-sm rounded-full mb-6">
          <i className="ri-arrow-up-circle-line text-teal-400 mr-2"></i>
          <span className="text-teal-300 font-medium text-sm whitespace-nowrap">Business Growth</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          The Technical Bottleneck: How Small Firms Win Big Contracts in Vancouver
        </h1>

        <p className="text-xl text-gray-300 mb-8 leading-relaxed">
          You have the crew, but do you have the drawings? Learn how outsourcing your Senior Detailer role allows a 5-person team to compete like a 50-person firm.
        </p>

        <div className="flex items-center justify-center space-x-6 text-gray-400">
          <div className="flex items-center">
            <i className="ri-calendar-line mr-2"></i>
            <span className="whitespace-nowrap">February 10, 2026</span>
          </div>
          <div className="flex items-center">
            <i className="ri-time-line mr-2"></i>
            <span className="whitespace-nowrap">6 min read</span>
          </div>
        </div>
      </div>
    </section>
  );
}
